import { bp } from 'lib/core/resources/helpers/styled'
import styled from 'styled-components'

export const Container = styled.div`
  position: sticky;
  color: ${props => props.theme.form.labelColor};
  top: 20px;
  width: 340px;
  box-sizing: border-box;
  margin-bottom: 30px;
  display: flex;
  flex-direction: column;
  ${bp('sm')`
    width: 100%;
  `}

  > div.overview {
    padding: 30px 15px;
    background: ${props => props.theme.palette.general.soft};

    tbody {
      td,
      th {
        font-size: 18px;
      }
    }
  }

  .linkWrapper {
    margin-left: auto;
    padding: 0;
    border-bottom: 0;
    font-size: 20px;
  }
`
